
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick, watchEffect } from 'vue'

import { useRoute } from 'vue-router'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10Api from '@/api/f10Api'
// import Pagination from '../pagination.vue'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    token: {
      type: String,
      default: function() {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      total: 0,
      pagination: {},
      spinning: true
    })
    pageData.total = computed(() => {
      return ((props.pageSourceData || {}).News || {}).Total
    })
    // pageData.data = computed(() => {
    //   const _data = ((props.pageSourceData || {}).News || {})
    //     .NewsOrNoticeDataData;
    //   if ((_data || []).length < 1) return [];
    //   _data.forEach((item: any, i: number) => {
    //     item.index = "News" + i;
    //     item.time = window.moment(item.PubTime * 1000).format("YYYY-MM-DD");
    //   });
    //   return _data;
    // });
    pageData.pagination = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        showTotal: (total: number) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: false,
        onChange: changeSize,
        onShowSizeChange: changeSize
      }
    })

    pageData.columns = [
      {
        title: '日期',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '媒体名称',
        dataIndex: 'Media',
        key: 'Media',
        width: '150px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '标题',
        dataIndex: 'zxTitle',
        key: 'zxTitle',
        ellipsis: true,
        slots: { customRender: 'link', type: 'link' }
      }
    ]
    watch(
      () => ((props.pageSourceData || {}).News || {}).NewsOrNoticeDataData,
      () => {
        const data = ((props.pageSourceData || {}).News || {}).NewsOrNoticeDataData
        pageData.data = handlerData(data)
        nextTick(() => {
          pageData.spinning = false
        })
      }
    )
    const route = useRoute()
    function getDetail(PageID: number, PageSize: number) {
      const data: any = {}
      data.data = {
        ExchInst: [
          {
            Exch: route.query.market,
            Inst: route.query.code
          }
        ],
        Org: [2],
        Tp: [1],
        PageID: PageID,
        PageSize: PageSize
      }
      data.headers = {
        token: props.token
      }
      f10Api.getGszxDetail(data).then((res: any) => {
        const arr = res && (res.Data || {}).NewsV2Data
        pageData.data = handlerData(arr)
      })
    }
    function handlerData(arr: any) {
      if ((arr || []).length) {
        arr.forEach((item: any, i: number) => {
          item.index = 'Gszx' + i
          item.time = window.moment(item.PubTime * 1000).format('YYYY-MM-DD')
          item.zxTitle = item.Title
        })
      }
      return arr
    }
    function changeSize(current: number, size: number) {
      getDetail(current, size)
      nextTick(() => {
        const wrapper: any = document.querySelector('.wrapper')
        const target: any = document.getElementById('gskd')
        wrapper.scrollTop = target.offsetTop
      })
    }
    return {
      ...toRefs(pageData)
      // changesize
    }
  }
})
